export enum WorkspaceFileUserStatus {
  Done = 'done',
  InProgress = 'inProgress'
}